import { X } from 'lucide-react';
import { useNotification } from '../../contexts/NotificationContext';

export const NotificationToast = () => {
  const { notifications, removeNotification } = useNotification();

  if (notifications.length === 0) return null;

  const getBackgroundColor = (type: string) => {
    switch (type) {
      case 'success':
        return 'bg-green-500';
      case 'error':
        return 'bg-red-500';
      case 'warning':
        return 'bg-yellow-500';
      case 'info':
      default:
        return 'bg-blue-500';
    }
  };

  return (
    <div className="fixed bottom-0 right-0 p-6 space-y-4 z-50">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`${getBackgroundColor(
            notification.type
          )} text-white p-4 rounded-lg shadow-lg flex items-center justify-between min-w-[300px] max-w-md transform transition-all duration-500 ease-in-out animate-fade-in`}
        >
          <p>{notification.message}</p>
          <button
            onClick={() => removeNotification(notification.id)}
            className="ml-4 text-white hover:text-gray-200 focus:outline-none"
          >
            <X size={20} />
          </button>
        </div>
      ))}
    </div>
  );
};